import * as THREE from "three"
import { MeshWobbleMaterial } from '@react-three/drei'
import { Canvas, useFrame, useThree } from 'react-three-fiber'
import create from "zustand"

import * as Tone from "tone"
import React, { Suspense, useRef, useCallback, useEffect, useMemo, useState } from "react"
import lerp from "lerp"
import { TweenMax, Sine, gsap } from "gsap"
import inst from "./inst"


let hitCount = 0
let isMobile = window.innerWidth < 500
let xWidth = isMobile ? 20 : 80

gsap.defaults({
  ease: Sine.easeOut
})
const col = 18
let getInst = () => {
  hitCount++
  return (hitCount % 2 === 0) ? inst.synthL : inst.synthR
}

function Rig() {
  const { camera, mouse } = useThree()
  const vec = new THREE.Vector3()
  const mutation = useStore(state => state.mutation)

  return useFrame(() => {

    //if(!mutation.cursor) return

    mutation.meter = lerp(mutation.meter, Math.abs(inst.meterL.getValue() + inst.meterR.getValue()) * (isMobile ? 200 : 400), 0.05)
    mutation.noteLen = lerp(mutation.noteLen, 0.05, mutation.mouseDown ? 0.1 : 0.2)

    mutation.inverter1.current.style.left = window.innerWidth/2+'px'
    mutation.inverter1.current.style.top = window.innerHeight/2+'px'
    mutation.inverter2.current.style.left = window.innerWidth/2+'px'
    mutation.inverter2.current.style.top = window.innerHeight/2+'px'
  })
}

function Loop({ mouse, i, sides, inside }) {
  let s = 2
  let w = 0.1
  const pattern = useStore(state => state['pattern' + i])
  const firstPattern = useStore(state => state['pattern0'])
  console.log('pattern', pattern)
  const mutation = useStore(state => state.mutation)
  const rings = useMemo(() => new Array(pattern.length).fill().map((v, i) => new THREE.TorusGeometry(s * ((i * (inside ? 0.5 : 3)) + (inside ? 0.2 : (1.0 * firstPattern.length))), w, 16, sides)), [pattern]);
  const mat = useMemo(() => new THREE.MeshStandardMaterial(), []);
  const ref = useRef();
  const count = useRef(0);
  const currMouse = useRef([...mouse, true]);
  const tweens = useRef([]);

  useEffect(() => {
    if (mutation.parts[i]) {
      currMouse.current[3] = false
      mutation.parts[i].stop()
      currMouse.current[2] = true
      setTimeout(() => {
        currMouse.current[2] = false
      }, 1000)
    }
    let part = new Tone.Part((function (time, value) {
      let s = getInst()
      s.triggerAttackRelease(value.note, value.dur, time, value.velocity);
      if (value.first) {
        count.current++
        let last = 0
        pattern.forEach((note, j) => {
          ref.current.children[j] && TweenMax.to(ref.current.children[j].scale, Math.min(note.dur * 0.6, 0.1), {
            delay: note.time,
            x: 1.25,
            y: 1.25,
            z: 1.25,
            onComplete: function () {
              ref.current.children[j] && TweenMax.to(ref.current.children[j].scale, -Math.min(note.dur * 0.1, 0.1) + pattern[pattern.length - 1].dur + pattern[pattern.length - 1].time, {
                x: 1,
                y: 1,
                z: 1,
              })
            }
          })
        })
      }
      currMouse.current[2] = true
      setTimeout(() => {
        currMouse.current[2] = false
      }, value.dur * 700)
    }), pattern)
    let last = 0.5 + (Math.random()*3)
    pattern.forEach((note, j) => {
      ref.current.children[j].material.factor =last
      TweenMax.to(ref.current.children[j].material, 1.2 - (j * 0.1), { factor: 0})
    })
    part.loop = true
    part.loopEnd = pattern[pattern.length - 1].dur + pattern[pattern.length - 1].time
    part.start()
    mutation.parts[i] = part
  }, [pattern]);

  const { size, viewport } = useThree();
  const aspect = size.width / viewport.width;

  useFrame(state => {
    let mousePosition = new THREE.Vector3(
      mouse[0] / aspect,
      -mouse[1] / aspect,
      0
    );
    ref.current.position.set(
      mousePosition.x,
      mousePosition.y,
      mousePosition.z
    );

    let size = 1 + mutation.meter

  });
  return (
    <>
      <group scale={[1.5,1.5,1.5]} ref={ref} >
        {new Array(rings.length).fill().map((v, i) => {
          return <mesh
            key={i}
            geometry={rings[i]}
            onClick={(e) => console.log('up')}
            onPointerDown={(e) => console.log('down')}
          >
            <MeshWobbleMaterial attach="material" speed={3} factor={0} />
          </mesh>
        })
        }
      </group>
    </>
  );
}

export default function () {
  const mutation = useStore(state => state.mutation)
  const set = useStore(state => state.set)
  const inverter1 = useRef()
  const inverter2 = useRef()
  const inverter3 = useRef()
  const cursor = useRef()
  const timeout = useRef()
  const randomizer = useRef()
  const randomizeTweens = useRef([])
  const inverted = useRef(false)

  const mouse = useRef([0, 0, false]);

  const onMouseMove = useCallback((e) => {
    mouse.current = [e.clientX - window.innerWidth / 2, e.clientY - window.innerHeight / 2, mouse.current[2]];
    if (e.buttons === 0) {
      mutation.mouseDown = false
    }
    mutation.pageX = e.pageX
    mutation.pageY = window.innerHeight - e.pageY
  },
    []
  );

  const handleMouseDown = event => {
    if (mutation.locked) return
    mutation.locked = true
    setTimeout(() => {
      mutation.locked = false
    }, 500)
    //mutation.parts.map((p, i) => p.start())
    Tone.Transport.start();
    set('pattern0', genPattern(2, 0.5, 0.5, 7))
    set('pattern1', genPattern(2,Math.random() > 0.5 ? 4 : 2, 0.4, 3))
    if (event.button !== 2) {
      mouse.current[2] = true;
    }
    //play(2)
    document.body.style.cursor = "none";
    mutation.mouseDown = true
    mutation.started = true
    randomize()
    clearTimeout(timeout.current)
    clearInterval(randomizer.current)
    randomizer.current = setInterval(() => {
      set('pattern0', genPattern(2, 0.5, 0.5, 7))
      set('pattern1', genPattern(2,Math.random() > 0.5 ? 4 : 2, 0.4, 3))
      randomize()
    }, 60000)
  };

  const handleMouseUp = event => {
    if (event.button !== 2) {
      mouse.current[2] = false;
    }
    mutation.mouseDown = false
  };

  useEffect(() => {
    setInterval(() => {
      if (mouse.current[2]) return
      mouse.current[2] = true
      timeout.current = setTimeout(() => {
        mouse.current[2] = false
      }, 600)
    }, 2000)

    mutation.inverter1 = inverter1
    mutation.inverter2 = inverter2
    mutation.cursor = cursor
  }, [])

  const play = useCallback((vel) => {
    let s = getInst()
    let hit = 0
    let punch = 0
    mutation.meter = mutation.meter + vel * 0.2
    mutation.noteLen = Math.min((mutation.noteLen + (vel)), 3)
    for (let i = 0; i < mutation.accent.length; i++) {
      if (hitCount % mutation.accent[i] === 0) {
        hit = 1200 / (mutation.accent[i])
        punch = 0.2
        //break;
      }
    }
    let freq = 30 + (isMobile ? (mutation.pageX * 1.75) : (mutation.pageY * 1.2)) + hit
    s.triggerAttackRelease(freq * 0.3, mutation.noteLen, '+0.001', vel + (Math.random() * 0.2) + punch);
  }, [])
  const newAccent = useCallback(() => {
    mutation.accent = ''
    new Array(9).fill().forEach((v, i) => Math.random() > 0.9 ? mutation.accent += (i + 1) : null)
  }, [])

  let ramps = ['linearRampTo', 'exponentialRampTo']
  const randomize = useCallback((vel) => {
    mutation.dirTarget = (Math.random() * 3) - 1.5

    let inverterSize = isMobile ? '240vh' : '300vw'
    inverter1.current.style.width = '0vh'
    inverter1.current.style.height = '0vh'

    inverter2.current.style.width = '0vh'
    inverter2.current.style.height = '0vh'
    randomizeTweens.current[0] && randomizeTweens.current[0].kill()
    randomizeTweens.current[1] && randomizeTweens.current[1].kill()
    if (inverted.current) {
      randomizeTweens.current[0] = TweenMax.to('.invert1', 2, { width: inverterSize,  height: inverterSize })
      inverter3.current.style.width = '0vh'
      inverter3.current.style.height = '0vh'
    } else {
      randomizeTweens.current[1] = TweenMax.to('.invert2', 2, { width: inverterSize,  height: inverterSize })
      inverter3.current.style.width = inverterSize
      inverter3.current.style.height = inverterSize
    }
    inverted.current = !inverted.current

    
  }, [])
  return (
    <>
      <Canvas camera={{ position: [0, 0, isMobile ? 80 : 70], fov: 80, far: 500 }}
        /*onPointerMove={mouseMove}
        onMouseMove={mouseMove}
        onMouseUp={mouseUp}

        onPointerDown={mouseDown}
        onPointerUp={mouseUp}
        */
        onPointerDown={(e) => isMobile && handleMouseDown(e)}
        onPointerMove={onMouseMove}
        onPointerUp={handleMouseUp}
        onMouseMove={onMouseMove}
        onMouseDown={(e) => !isMobile && handleMouseDown(e)}
        onMouseUp={handleMouseUp}
        gl={{ antialias: true }}
        //pixelRatio={0.4 * window.devicePixelRatio}
        onCreated={({ gl }) => {
          gl.toneMapping = THREE.ACESFilmicToneMapping
          gl.outputEncoding = THREE.sRGBEncoding
        }}
      >
        <ambientLight intensity={0.4} />
        <spotLight
          position={[10, 10, 10]}
          angle={0.2}
          penumbra={1}
          intensity={0.2}
        />
        <Rig />
        <directionalLight position={[-1, 4, -2]} intensity={2} color="white" />
        <pointLight position={[-1, -4, -0]} intensity={3} color="white" />
        <Loop mouse={[0, 0, false]} i={0} sides={100} inside={true} />
        <Loop mouse={[0, 0, false]} i={1} sides={4} inside={false} />
      </Canvas>
      <div ref={inverter1} className='invert1' />
      <div ref={inverter2} className='invert2' />
      <div ref={inverter3} className='invert3' />
    </>
  )
}

let notes = ["C", "D", 'E', 'F', 'G', 'A']
let timeSteps = [0.2, 0.3, 0.2, 0.25, 0.4, 0.3]
let genPattern = (oct, durMult, vol, len) => {
  let t = 0
  return new Array(Math.ceil(Math.random() * len)).fill().map((v, i) => {
    let dur = timeSteps[Math.floor(Math.random() * timeSteps.length)] * durMult
    let note = {
      i,
      note: notes[Math.floor(Math.random() * notes.length)] + (oct + Math.round(Math.random() * 3)),
      time: t,
      dur: dur,
      velocity: vol * 0.5 + (vol * Math.random()),
      first: (i === 0)
    }
    t += dur
    return note
  })
}

const [useStore] = create((set, get) => ({
  startTime: null,
  started: false,
  sequence: [],
  pattern0: genPattern(1, 1, 0.6, 1),
  pattern1: genPattern(1, 3, 1.5, 1),
  mutation: {
    parts: [],
    cursor: null,
    mouseDown: false,
    pageX: window.innerWidth / 2,
    pageY: window.innerHeight / 2,
    meter: 0,
    timeSpeed: 0,
    interval: '2',
    dir: 0,
    dirTarget: 0,
    locked: false,
    front: 1,
    accent: '8',
    noteLen: 0.5,
    started: false,
  },
  set: (key, val) => set(() => {
    return { [key]: val };
  }),
}))

console.log('%c🌱🌱 @ramioso 2021-05-27 🌱🌱 ', 'color: orange');